// 从 src/framework/editor/src/js/utils/index.js 迁移过来
export function getSrcRectByLong(width: number, height: number, imgWidth: number, imgHeight: number) {
    if (!width || !height || !imgWidth || !imgHeight) {
        return {
            l: 0,
            r: 0,
            t: 0,
            b: 0,
        };
    }

    const ratioX = imgWidth / width;
    const ratioY = imgHeight / height;
    const ratio = ratioX > ratioY ? ratioY : ratioX;
    const srcRectRatioW = roundToDecimalPlaces(((width * ratio) - imgWidth) / (width * ratio * 2), 2);
    const srcRectRatioH = roundToDecimalPlaces(((height * ratio) - imgHeight) / (height * ratio * 2), 2);

    return {
        l: srcRectRatioW,
        r: srcRectRatioW,
        t: srcRectRatioH,
        b: srcRectRatioH,
    };
}

// Rounds a number to the given number of decimal places.
function roundToDecimalPlaces(number: number, decimalPlaces: number) {
    const multiplier = Math.pow(10, decimalPlaces);
    return Math.round(number * multiplier) / multiplier;
}
